const waiting = new Set();
const registered = new WeakSet();
const hero = document.querySelector('.mv-home-slide.is-active img, .mv-campaign__image');
let ready = !hero || (hero.complete && hero.naturalWidth > 0);
function load(image, priority = 'low') {
  if (!image.dataset.mvSrc) return;
  image.fetchPriority = priority;
  if (image.dataset.mvSrcset) image.srcset = image.dataset.mvSrcset;
  image.src = image.dataset.mvSrc;
  image.loading = 'eager';
  delete image.dataset.mvSrc;
  delete image.dataset.mvSrcset;
  waiting.delete(image);
  observer.unobserve(image);
}
const observer = new IntersectionObserver(entries => {
  for (const entry of entries) {
    if (!entry.isIntersecting) {waiting.delete(entry.target);continue}
    if (ready) load(entry.target); else waiting.add(entry.target);
  }
}, {rootMargin: '600px 0px'});
function register(root) {
  const images = [...root.querySelectorAll('img[data-mv-src]')];
  if (root.matches?.('img[data-mv-src]')) images.push(root);
  for (const image of images) {
    const menu = image.closest('details.mv-mega');
    if (menu) {if (menu.open) load(image, 'high');continue}
    if (registered.has(image)) continue;
    registered.add(image);
    observer.observe(image);
  }
}
if (!ready) hero.decode().catch(() => {}).finally(() => {
  ready = true;
  for (const image of waiting) if (image.isConnected) load(image);
});
document.addEventListener('toggle', event => {
  if (event.target.matches?.('details.mv-mega[open]')) register(event.target);
}, true);
new MutationObserver(records => {
  for (const record of records) for (const node of record.addedNodes) {
    if (node instanceof Element) register(node);
  }
}).observe(document.body, {childList: true, subtree: true});
register(document);
